import CloseIcon from "@mui/icons-material/Close"
import { Box, Button, DialogTitle, IconButton, Tab } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import {  useEffect, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import CustomTextField from "../CustomTextField"
import { useSelector } from "react-redux"
import CustomSearchSelect from "../CustomSearchSelect"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

const opcionesMotivoCancelar = [
  { value: 100000000, label: "Cambio de Posición" },
  { value: 100000001, label: "Objetivo definido incorrectamente" },
  { value: 100000002, label: "Definición institucional" },
];

const ModalCancelarObjetivo = ({ open, handleClose, objetivo, idPGD }) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
  const [valuePrimerTab, setValuePrimerTab] = useState('1'); //value del tablist

  const defaultValues = {
    id: null,
    name: null,
    motivoCancelar : null,
  }
  const validacionSchema = yup.object().shape({
    motivoCancelar: yup.object().required("Por favor selecciona una competencia."),
  });

  const { handleSubmit, setValue, reset, ...methods } = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })
  
  const submitDatos = (datos) => {
    console.log("Datos: ",datos)
    //Enviar sólo lo necesario
    handleClose(datos, idPGD, datos.index)
    reset()
  }

  // useEffect(() => {
  //   reset(objetivo)
  // }, [objetivo, reset])
  useEffect(() => {
    if (objetivo) {
      Object.keys(objetivo).forEach((key) => {
        setValue(key, objetivo[key]);
      });
    }
  }, [objetivo, setValue]);

  const cerrarModal = () => {
    handleClose()
    reset()
    setValuePrimerTab("1")
  }

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          cerrarModal();
        }
      }}
      aria-labelledby="responsive-dialog-title"
      disableEscapeKeyDown={true}
    >
        <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={cerrarModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
      <TabContext value={valuePrimerTab}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <TabList
              aria-label="scrollable force tabs example"
              onChange={handleChangePrimerTAB} variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              textColor="secondary"
              indicatorColor="secondary"
            >
              <Tab label="Cancelar Objetivo" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
            </TabList>
          </Box>
          <TabPanel value="1">



        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                <CustomSearchSelect
                    options={opcionesMotivoCancelar}
                    type="text"
                    name="motivoCancelar"
                    lab="Motivo de Cancelación de objetivo"
                    helperText="El motivo de la cancelación es requerido"
                />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 3 }}>
                <Button sx={{ pr: 10, pl:10}}
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="error"
                    onClick={handleSubmit(submitDatos)}
                >
                Confirmar
                </Button>
            </Grid>
          </FormProvider>
        </Grid>



        </TabPanel>
        </TabContext>

      </DialogContent>
    </Dialog>
  )
}

export default ModalCancelarObjetivo
